import React from 'react';
import PropTypes from 'prop-types';
import { Fade, CircularProgress as RawCircularProgress } from '@material-ui/core';

function CircularProgress(props) {
  const { noDelay, className } = props;
  return (
    <Fade in style={{ transitionDelay: noDelay ? '0ms' : '800ms' }} unmountOnExit>
      <RawCircularProgress className={className} />
    </Fade>
  );
}

CircularProgress.propTypes = {
  noDelay: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
};

export default CircularProgress;


// WEBPACK FOOTER //
// ./src/components/CircularProgress.jsx